/* Bloque «Instalación» + «Recomendado con tu…» de la ficha
 * (snippets/fls-pdp-instalacion.liquid).
 *
 * - Radio «Solo el equipo» / «Con instalación»; región → comuna (JSON de
 *   fls-comunas-cl); «Otra región» bloquea el «Agregar» y ofrece cotizar por
 *   WhatsApp.
 * - Casilla del recomendado (la manta): si se vende por m² pide ancho × largo
 *   y calcula ceil(ancho × largo) como fibrolab-m2-calculator.js.
 * - Intercepta el submit del formulario en fase de captura (corre antes que
 *   product-form.js) SOLO cuando hay instalación o recomendado, y hace un único
 *   POST /cart/add.js con 2 o 3 líneas. Sin extras deja pasar a Dawn.
 * - La línea de instalación lleva la propiedad oculta _equipo_variant, que
 *   assets/fls-cart-companion.js usa para quitarla o igualar su cantidad
 *   cuando la bomba cambia en el carrito.
 */
(function () {
  if (window.customElements.get('fls-pdp-instalacion')) return;

  // Mismo formato que el resto de la página (shop.money_format, p. ej. «${{amount}}»
  // → «$299,990»), no el de Intl es-CL, que pone puntos.
  var MONEY_FORMAT = '${{amount}}';
  function money(cents) {
    var n = Math.round(cents) / 100;
    var m = MONEY_FORMAT.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var locale = key.indexOf('comma_separator') !== -1 ? 'de-DE' : 'en-US';
    var s = n.toLocaleString(locale, { maximumFractionDigits: 0 });
    return m ? MONEY_FORMAT.replace(m[0], s) : '$' + s;
  }
  function fmt1(n) { return n.toFixed(1).replace('.', ','); }
  function parseNum(raw) {
    if (raw == null) return NaN;
    var cleaned = String(raw).trim().replace(/\s/g, '').replace(',', '.');
    if (!/^[0-9]*\.?[0-9]+$/.test(cleaned)) return NaN;
    return parseFloat(cleaned);
  }
  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_) { return null; }
  }

  class FlsPdpInstalacion extends HTMLElement {
    connectedCallback() {
      var d = this.dataset;
      this.sectionId = d.section;
      this.productVariant = Number(d.variant) || 0;
      this.productPrice = Number(d.productPrice) || 0;
      this.productTitle = d.productTitle || '';
      this.productUrl = d.productUrl || window.location.href;
      this.wa = d.wa || '';
      if (d.moneyFormat) MONEY_FORMAT = d.moneyFormat;

      this.variants = readJSON(this.querySelector('[data-fls-inst-variants]')) || [];
      this.comunas = readJSON(this.querySelector('[data-fls-comunas]')) || {};

      var q = this.querySelector.bind(this);
      this.modeInputs = Array.prototype.slice.call(this.querySelectorAll('[data-fls-inst-mode]'));
      this.panel = q('[data-fls-inst-panel]');
      this.regionSel = q('[data-fls-inst-region]');
      this.comunaRow = q('[data-fls-inst-comuna-row]');
      this.comunaSel = q('[data-fls-inst-comuna]');
      this.quoteBox = q('[data-fls-inst-quote]');
      this.otraInput = q('[data-fls-inst-otra]');
      this.quoteLink = q('[data-fls-inst-quote-link]');

      this.reco = q('[data-fls-reco]');
      this.recoCheck = q('[data-fls-reco-check]');
      this.recoM2 = q('[data-fls-reco-m2]');
      this.recoAncho = q('[data-fls-reco-input="ancho"]');
      this.recoLargo = q('[data-fls-reco-input="largo"]');
      this.recoArea = q('[data-fls-reco-area]');
      this.recoSubtotal = q('[data-fls-reco-subtotal]');
      this.recoError = q('[data-fls-reco-error]');

      this.summary = q('[data-fls-inst-summary]');
      this.sumEquipo = q('[data-fls-inst-sum-equipo]');
      this.sumRowInst = q('[data-fls-inst-sum-row="inst"]');
      this.sumRegion = q('[data-fls-inst-sum-region]');
      this.sumInst = q('[data-fls-inst-sum-inst]');
      this.sumRowReco = q('[data-fls-inst-sum-row="reco"]');
      this.sumRecoLabel = q('[data-fls-inst-sum-reco-label]');
      this.sumReco = q('[data-fls-inst-sum-reco]');
      this.sumTotal = q('[data-fls-inst-sum-total]');
      this.errorEl = q('[data-fls-inst-error]');

      this.form = document.getElementById(d.form);
      this.submitBtn = null;
      this.qtyInput = null;
      if (this.form) {
        this.submitBtn = this.form.querySelector('[type="submit"][name="add"]');
        this.qtyInput = this.form.elements.namedItem('quantity');
        // Captura: corre antes que el listener de product-form.js (mismo truco
        // que fibrolab-m2-calculator.js).
        this.form.addEventListener('submit', this.onSubmit.bind(this), { capture: true });
      }
      this.submitLocked = false;
      this.submitWasDisabled = false;

      // «Consultar por WhatsApp» (fibrolab-pdp-whatsapp.liquid) recibe la selección.
      this.waBtn = document.querySelector('[data-fls-wa]');

      // Línea extra bajo el precio de la barra sticky (fuera de #FbStickyPrice,
      // que fibrolab-pdp.js reescribe entero al sincronizar).
      var stickyPrice = document.getElementById('FbStickyPrice-' + this.sectionId);
      this.sticky = null;
      if (stickyPrice) {
        this.sticky = document.createElement('span');
        this.sticky.className = 'fls-inst__sticky';
        this.sticky.hidden = true;
        stickyPrice.insertAdjacentElement('afterend', this.sticky);
      }

      var self = this;
      this.modeInputs.forEach(function (r) { r.addEventListener('change', function () { self.onModeChange(); }); });
      if (this.regionSel) this.regionSel.addEventListener('change', function () { self.onRegionChange(); });
      if (this.comunaSel) this.comunaSel.addEventListener('change', function () { self.update(); });
      if (this.otraInput) this.otraInput.addEventListener('input', function () { self.update(); });
      if (this.recoCheck) this.recoCheck.addEventListener('change', function () { self.onRecoToggle(); });
      [this.recoAncho, this.recoLargo].forEach(function (el) {
        if (!el) return;
        el.addEventListener('input', function () { self.update(); });
        el.addEventListener('blur', function () { self.normalize(el); });
      });
      if (this.qtyInput) {
        this.qtyInput.addEventListener('change', function () { self.update(); });
        this.qtyInput.addEventListener('input', function () { self.update(); });
      }

      this.onModeChange();
    }

    get mode() {
      var r = this.modeInputs.filter(function (i) { return i.checked; })[0];
      return r ? r.value : 'none';
    }

    onModeChange() {
      var on = this.mode === 'install';
      if (this.panel) this.panel.hidden = !on;
      if (!on && this.regionSel) this.regionSel.value = '';
      this.onRegionChange();
      if (on && this.regionSel && !this.regionSel.value) this.regionSel.focus();
    }

    onRegionChange() {
      var v = this.regionSel ? this.regionSel.value : '';
      var valid = !!v && v !== 'quote';
      if (this.comunaRow) this.comunaRow.hidden = !valid;
      if (this.quoteBox) this.quoteBox.hidden = v !== 'quote';
      if (this.comunaSel) {
        var list = [];
        if (valid) {
          var opt = this.regionSel.options[this.regionSel.selectedIndex];
          var region = opt ? opt.dataset.region : '';
          list = this.comunas[region];
          if (!list) { console.warn('[fls-inst] región sin comunas en fls-comunas-cl:', region); list = []; }
        }
        this.fillComunas(list);
      }
      this.update();
    }

    fillComunas(list) {
      var sel = this.comunaSel;
      var prev = sel.value;
      sel.innerHTML = '';
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = 'Elige tu comuna';
      sel.appendChild(ph);
      list.forEach(function (c) {
        var o = document.createElement('option');
        o.value = c;
        o.textContent = c;
        sel.appendChild(o);
      });
      if (list.indexOf(prev) !== -1) sel.value = prev;
    }

    onRecoToggle() {
      var on = !!(this.recoCheck && this.recoCheck.checked);
      if (this.recoM2) this.recoM2.hidden = !on;
      if (on && this.recoAncho && !this.recoAncho.value) this.recoAncho.focus();
      this.update();
    }

    normalize(el) {
      var v = parseNum(el.value);
      if (isNaN(v) || v <= 0) {
        el.value = '';
      } else {
        el.value = (Math.round(v * 10) / 10).toString().replace('.', ',');
      }
      this.update();
    }

    getState() {
      var qty = Math.max(1, parseInt(this.qtyInput && this.qtyInput.value, 10) || 1);
      var install = { active: this.mode === 'install', quote: false, variantId: null, region: '', price: 0, comuna: '' };
      if (install.active && this.regionSel) {
        var v = this.regionSel.value;
        if (v === 'quote') {
          install.quote = true;
        } else if (v) {
          var opt = this.regionSel.options[this.regionSel.selectedIndex];
          install.variantId = Number(v) || null;
          install.region = (opt && opt.dataset.region) || '';
          install.price = Number(opt && opt.dataset.price) || 0;
          install.comuna = this.comunaSel ? this.comunaSel.value : '';
        }
      }
      var reco = { active: false, m2: false, qty: 0, valid: false, tooBig: false, price: 0, ancho: 0, largo: 0,
                   title: '', variantId: null, min: 1, max: 200, unit: 0 };
      if (this.reco && this.recoCheck && this.recoCheck.checked && this.reco.dataset.available === 'true') {
        var rd = this.reco.dataset;
        reco.active = true;
        reco.m2 = rd.m2 === 'true';
        reco.variantId = Number(rd.variant) || null;
        reco.unit = Number(rd.price) || 0;
        reco.title = rd.title || '';
        reco.min = Number(rd.minM2) || 1;
        reco.max = Number(rd.maxM2) || 200;
        if (reco.m2) {
          var a = parseNum(this.recoAncho && this.recoAncho.value);
          var l = parseNum(this.recoLargo && this.recoLargo.value);
          if (a > 0 && l > 0) {
            reco.ancho = a;
            reco.largo = l;
            reco.qty = Math.max(reco.min, Math.ceil(a * l));
            reco.tooBig = reco.qty > reco.max;
            reco.valid = !reco.tooBig;
          }
        } else {
          reco.qty = 1;
          reco.valid = true;
        }
        reco.price = reco.valid ? reco.unit * reco.qty : 0;
      }
      var total = this.productPrice * qty
        + (install.active && install.variantId ? install.price * qty : 0)
        + (reco.active && reco.valid ? reco.price : 0);
      return { qty: qty, install: install, reco: reco, total: total };
    }

    update() {
      var s = this.getState();
      var showInst = s.install.active && !!s.install.variantId;
      var showReco = s.reco.active && s.reco.valid;

      if (this.summary) {
        this.summary.hidden = !(s.install.active || s.reco.active);
        this.sumEquipo.textContent = s.qty > 1
          ? s.qty + ' × ' + money(this.productPrice) + ' = ' + money(this.productPrice * s.qty)
          : money(this.productPrice);
        this.sumRowInst.hidden = !showInst;
        if (showInst) {
          this.sumRegion.textContent = s.install.region;
          this.sumInst.textContent = s.qty > 1
            ? s.qty + ' × ' + money(s.install.price) + ' = ' + money(s.install.price * s.qty)
            : money(s.install.price);
        }
        this.sumRowReco.hidden = !showReco;
        if (showReco) {
          this.sumRecoLabel.textContent = s.reco.m2 ? s.reco.title + ' · ' + s.reco.qty + ' m²' : s.reco.title;
          this.sumReco.textContent = money(s.reco.price);
        }
        this.sumTotal.textContent = money(s.total);
      }

      if (this.recoArea && s.reco.active && s.reco.m2) {
        if (s.reco.ancho > 0 && s.reco.largo > 0) {
          this.recoArea.textContent = s.reco.qty + ' m² (' + fmt1(s.reco.ancho) + ' × ' + fmt1(s.reco.largo) + ' m)';
          this.recoSubtotal.textContent = s.reco.valid ? '· ' + money(s.reco.price) : '';
        } else {
          this.recoArea.textContent = 'Ingresa ancho y largo';
          this.recoSubtotal.textContent = '';
        }
        if (this.recoError) {
          this.recoError.hidden = !s.reco.tooBig;
          if (s.reco.tooBig) {
            this.recoError.textContent = 'La superficie máxima es ' + s.reco.max + ' m². Para piscinas más grandes escríbenos por WhatsApp.';
          }
        }
      }

      // El «Agregar» solo se bloquea con «Otra región»: ahí no hay precio.
      this.lockSubmit(s.install.active && s.install.quote);

      if (this.sticky) {
        var parts = [];
        if (showInst) parts.push('instalación');
        if (showReco) parts.push(s.reco.m2 ? 'manta' : 'extra');
        this.sticky.hidden = parts.length === 0;
        if (parts.length) this.sticky.textContent = 'Total con ' + parts.join(' y ') + ': ' + money(s.total);
      }

      if (this.quoteLink) this.quoteLink.href = this.waUrl(this.msgCotizar(s), this.wa);
      if (this.waBtn) this.waBtn.href = this.waUrl(this.msgConsultar(s), this.waBtn.dataset.waNumber || this.wa);

      if (this.errorEl) { this.errorEl.hidden = true; this.errorEl.textContent = ''; }
    }

    lockSubmit(lock) {
      if (!this.submitBtn || lock === this.submitLocked) return;
      if (lock) {
        this.submitWasDisabled = this.submitBtn.hasAttribute('disabled');
        if (!this.submitWasDisabled) {
          this.submitBtn.setAttribute('disabled', '');
          this.submitBtn.setAttribute('aria-disabled', 'true');
        }
      } else if (!this.submitWasDisabled) {
        this.submitBtn.removeAttribute('disabled');
        this.submitBtn.removeAttribute('aria-disabled');
      }
      this.submitLocked = lock;
    }

    waUrl(text, number) {
      return 'https://wa.me/' + (number || this.wa) + '?text=' + encodeURIComponent(text);
    }

    ubicacion() {
      var t = this.otraInput ? this.otraInput.value.trim() : '';
      return t || 'otra región (no listada)';
    }

    msgCotizar(s) {
      var t = 'Hola 👋 Quiero cotizar la instalación de una bomba de calor.'
        + '\nEquipo: ' + this.productTitle
        + '\n' + this.productUrl
        + '\nUbicación: ' + this.ubicacion();
      if (s.qty > 1) t += '\nCantidad: ' + s.qty;
      return t;
    }

    msgConsultar(s) {
      var base = (this.waBtn && this.waBtn.dataset.waBase) || ('Hola 👋 Me interesa este producto: ' + this.productTitle);
      var t = base;
      if (s.install.active && s.install.variantId) {
        t += '\nInstalación: Con instalación · ' + s.install.region + (s.install.comuna ? ' · ' + s.install.comuna : '');
      } else if (s.install.active && s.install.quote) {
        t += '\nInstalación: cotizar para ' + this.ubicacion();
      }
      if (s.reco.active && s.reco.valid) {
        t += '\n+ ' + s.reco.title + (s.reco.m2 ? ' ' + s.reco.qty + ' m² (' + fmt1(s.reco.ancho) + ' × ' + fmt1(s.reco.largo) + ' m)' : '');
      }
      t += '\n' + ((this.waBtn && this.waBtn.dataset.waUrl) || this.productUrl);
      return t;
    }

    fail(msg, focusEl, errEl) {
      var el = errEl || this.errorEl;
      if (el) { el.hidden = false; el.textContent = msg; }
      if (focusEl && typeof focusEl.focus === 'function') focusEl.focus();
    }

    async onSubmit(e) {
      var s = this.getState();
      if (!s.install.active && !s.reco.active) return; // sin extras: Dawn agrega el equipo solo
      e.preventDefault();
      e.stopImmediatePropagation();

      if (s.install.active) {
        if (s.install.quote) return this.fail('Para otras regiones cotizamos la instalación por WhatsApp.', this.quoteLink);
        if (!s.install.variantId) return this.fail('Elige tu región para la instalación.', this.regionSel);
        if (!s.install.comuna) return this.fail('Elige tu comuna.', this.comunaSel);
      }
      if (s.reco.active && !s.reco.valid) {
        return this.fail(
          s.reco.tooBig ? 'La superficie máxima es ' + s.reco.max + ' m².' : 'Ingresa el ancho y largo de tu piscina para la manta térmica.',
          this.recoAncho, this.recoError
        );
      }

      var variantInput = this.form.querySelector('[name="id"]');
      var variantId = Number(variantInput && variantInput.value) || this.productVariant;
      if (!variantId) return this.fail('Variante no disponible.');

      var items = [{ id: variantId, quantity: s.qty }];
      if (s.install.active) {
        items[0].properties = { 'Instalación': 'Con instalación · ' + s.install.region + ' · ' + s.install.comuna };
        items.push({
          id: s.install.variantId,
          quantity: s.qty,
          properties: { 'Equipo': this.productTitle, 'Comuna': s.install.comuna, '_equipo_variant': String(variantId) },
        });
      }
      if (s.reco.active) {
        var it = { id: s.reco.variantId, quantity: s.reco.qty };
        if (s.reco.m2) {
          it.properties = {
            'Ancho': fmt1(s.reco.ancho) + ' m',
            'Largo': fmt1(s.reco.largo) + ' m',
            'Superficie': s.reco.qty + ' m² (' + fmt1(s.reco.ancho) + ' × ' + fmt1(s.reco.largo) + ' m)',
          };
        }
        items.push(it);
      }

      var cartUi = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = { items: items };
      if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
        body.sections = cartUi.getSectionsToRender().map(function (x) { return x.id; }).join(',');
        body.sections_url = window.location.pathname;
        if (typeof cartUi.setActiveElement === 'function') cartUi.setActiveElement(document.activeElement);
      }

      this.setLoading(true);
      try {
        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        var res = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
        var data = await res.json();
        if (data && data.status) {
          this.fail(data.description || data.message || 'No se pudo agregar al carrito.');
          return;
        }
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fls-pdp-instalacion', productVariantId: variantId, cartData: data }); } catch (_) {}
        }
        if (cartUi && data.sections) {
          if (cartUi.classList.contains('is-empty')) cartUi.classList.remove('is-empty');
          cartUi.renderContents(data);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (err) {
        console.error('[fls-inst] cart add failed', err);
        this.fail('Ocurrió un error al agregar al carrito. Intenta nuevamente.');
      } finally {
        this.setLoading(false);
      }
    }

    setLoading(loading) {
      if (!this.submitBtn) return;
      this.submitBtn.classList.toggle('loading', loading);
      var spinner = this.submitBtn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !loading);
      if (loading) this.submitBtn.setAttribute('aria-disabled', 'true');
      else if (!this.submitLocked && !this.submitWasDisabled) this.submitBtn.removeAttribute('aria-disabled');
    }
  }

  customElements.define('fls-pdp-instalacion', FlsPdpInstalacion);
})();
